var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.946 8.7585L18.321 16.8375H5.625L3 8.7585L8.1789 11.6784L11.973 4.5L15.7671 11.6784L20.946 8.7585Z",
    fill: "url(#paint0_linear_4005_76989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9463 8.7589L21.5169 8.9443C21.5542 8.82941 21.556 8.70593 21.5219 8.59003C21.4879 8.47413 21.4197 8.37119 21.3262 8.2947C21.2327 8.2182 21.1183 8.1717 20.998 8.16128C20.8776 8.15086 20.7569 8.17701 20.6517 8.2363L20.9463 8.7589ZM18.3213 16.8379V17.4379C18.448 17.4379 18.5715 17.3978 18.674 17.3233C18.7765 17.2488 18.8528 17.1438 18.8919 17.0233L18.3213 16.8379ZM5.62531 16.8379L5.05471 17.0233C5.09386 17.1438 5.17015 17.2488 5.27265 17.3233C5.37516 17.3978 5.4986 17.4379 5.62531 17.4379V16.8379ZM3.00031 8.7589L3.29491 8.2363C3.18967 8.17701 3.06898 8.15086 2.94864 8.16128C2.82829 8.1717 2.7139 8.2182 2.62041 8.2947C2.52693 8.37119 2.45871 8.47413 2.42469 8.59003C2.39066 8.70593 2.39241 8.82941 2.42971 8.9443L3.00031 8.7589ZM8.17921 11.6788L7.88461 12.2014C7.95442 12.2408 8.03141 12.2657 8.11103 12.2748C8.19066 12.2839 8.2713 12.277 8.3482 12.2544C8.4251 12.2319 8.4967 12.1941 8.55877 12.1434C8.62084 12.0928 8.67213 12.0301 8.70961 11.9593L8.17921 11.6788ZM11.9733 4.5004L12.5037 4.2199C12.4527 4.12345 12.3764 4.04274 12.2829 3.98644C12.1895 3.93014 12.0824 3.90039 11.9733 3.90039C11.8642 3.90039 11.7572 3.93014 11.6637 3.98644C11.5702 4.04274 11.4939 4.12345 11.4429 4.2199L11.9733 4.5004ZM15.7674 11.6788L15.237 11.9593C15.2745 12.0301 15.3258 12.0928 15.3878 12.1434C15.4499 12.1941 15.5215 12.2319 15.5984 12.2544C15.6753 12.277 15.756 12.2839 15.8356 12.2748C15.9152 12.2657 15.9922 12.2408 16.062 12.2014L15.7674 11.6788ZM20.3757 8.5738L17.7507 16.6525L18.8919 17.0233L21.5169 8.9443L20.3757 8.5738ZM18.3213 16.2376H5.62531V17.4379H18.3213V16.2376ZM6.19591 16.6522L3.57091 8.5732L2.42971 8.9443L5.05471 17.0233L6.19591 16.6522ZM2.70571 9.2815L7.88461 12.2014L8.47351 11.1562L3.29461 8.2363L2.70571 9.2815ZM8.70961 11.9593L12.5037 4.7809L11.4429 4.2199L7.64881 11.3986L8.70961 11.9593ZM11.4426 4.7809L15.237 11.9593L16.2981 11.3983L12.5037 4.2199L11.4426 4.7809ZM16.062 12.2014L21.2415 9.2815L20.6517 8.2363L15.4731 11.1562L16.062 12.2014Z",
    fill: "url(#paint1_linear_4005_76989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9736 19.5H5.97363",
    stroke: "url(#paint2_linear_4005_76989)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4005_76989",
    x1: 11.973,
    y1: 4.5,
    x2: 11.973,
    y2: 16.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC881E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261428,
    stopColor: "#F6EF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632068,
    stopColor: "#D0A946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2CB69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4005_76989",
    x1: 11.9733,
    y1: 3.90039,
    x2: 11.9733,
    y2: 17.4379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC881E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261428,
    stopColor: "#F6EF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632068,
    stopColor: "#D0A946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2CB69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4005_76989",
    x1: 11.9736,
    y1: 19.5,
    x2: 11.9736,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC881E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261428,
    stopColor: "#F6EF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632068,
    stopColor: "#D0A946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2CB69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeIcon);
export default __webpack_public_path__ + "static/media/subscribeIcon.ca8e7661873a2cc43b2aafac986bacdb.svg";
export { ForwardRef as ReactComponent };